<template>
  <div class="wrapper" v-loading="loading">
    <div
      ref="pageView"
      class="all-content container-view"
      :class="{ 'is-hide': isActiveCode === 2 }"
    >
      <!-- title start -->
      <section class="title clearfix fixed-view">
        <div class="title-name fl"><!--冷库监控--></div>
        <div class="oprate">
          <el-checkbox v-model="checked" @change="autoRefreshEvent"
            >自动刷新
          </el-checkbox>
          <i class="e6-icon-refresh_line" @click="getInitData"></i>
          <span class="refresh-icon" @click="getInitData">手动刷新</span>
          <i
            class="search-icon e6-icon-search_line"
            @click="handleSearchFormVisible"
          ></i>
        </div>
      </section>
      <!-- title end -->
      <!-- 查询条件 start -->
      <section class="search fixed-view" v-show="searchFormVisible">
        <el-form class="searchForm" ref="searchForm" :model="searchForm">
          <el-form-item class="search-item fl" prop="comparyIdList">
            <el-select
              v-model="searchForm.comparyIdList"
              placeholder="企业名称"
              filterable
              multiple
              collapse-tags
              clearable
              class="select-limit"
            >
              <el-option
                v-for="item in allComparys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="search-item fl" prop="storageName">
            <el-input
              v-model="searchForm.storageName"
              placeholder="冷库名称"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item fl" prop="countyNameId">
            <!--<dict-select-->
            <!--v-model="searchForm.countyNameId"-->
            <!--placeholder="所属区(县)"-->
            <!--:pkey="'county_name'"-->
            <!--&gt;</dict-select>-->
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <el-form-item class="search-item fl" prop="storageMold">
            <dict-select
              v-model="searchForm.storageMold"
              placeholder="仓库类型"
              :pkey="'storage_mold'"
              clearable
            ></dict-select>
          </el-form-item>
          <el-form-item class="search-item fl">
            <el-button type="primary" @click="handleQuery()">查询</el-button>
          </el-form-item>
          <el-form-item class="search-item fl">
            <el-button type="primary" plain @click="handleReset">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </section>
      <!-- 查询条件 end -->
      <!-- 状态筛选操作按钮 start -->
      <section class="info-row fixed-view clearfix">
        <el-radio-group v-model="chooseStatus" @change="selectStatus">
          <el-radio-button class="status-btn" label="0">全部</el-radio-button>
          <el-radio-button class="status-btn" label="1">正常</el-radio-button>
          <el-radio-button class="status-btn" label="2">报警</el-radio-button>
          <el-radio-button class="status-btn" label="3">掉线</el-radio-button>
        </el-radio-group>
        <span class="all-msg"
          >共{{ comparyAllCount }}家企业，{{ storageAllCount }}个仓库，{{
            areaAllCount
          }}个区位，{{ labelAllCount }}个监测点</span
        >
        <div class="show-all fr" @click="handleIsAllShow">
          {{ isAllShow }}
          <i class="el-icon-arrow-down" v-show="openningList.length"></i>
          <i class="el-icon-arrow-right" v-show="!openningList.length"></i>
        </div>
      </section>
      <!-- 状态筛选操作按钮 end -->
      <!-- 主体内容 start -->
      <div class="content">
        <div
          class="all-info-wrapper"
          element-loading-text="数据加载中"
          :style="`height: ${resizeViewHeight - 20 - 28 - 50 - searchHeight}px`"
          ref="company"
        >
          <!-- 动态加载公司 -->
          <div
            class="company"
            v-for="corp in comparyList"
            :key="corp.comparyId"
          >
            <div
              class="company-title clearfix"
              @click.self="isShowCompary(corp.comparyId)"
            >
              <div class="company-title-info fl">
                <i class="company-icon"></i>
                <span class="company-name">{{ corp.comparyName }}</span>
              </div>
              <div class="show-icon fr">
                <i
                  class="el-icon-arrow-down"
                  @click.self="isShowCompary(corp.comparyId)"
                  v-show="isOpenning('corp-' + corp.comparyId)"
                ></i>
                <i
                  class="el-icon-arrow-right"
                  @click.self="isShowCompary(corp.comparyId)"
                  v-show="!isOpenning('corp-' + corp.comparyId)"
                ></i>
              </div>
            </div>
            <!-- 仓库列表 -->
            <div class="storage-list-wrapper clearfix">
              <!-- 仓库 -->
              <div
                v-show="isOpenning('corp-' + corp.comparyId)"
                class="storage clearfix"
                v-for="storage in corp.storageList"
                :key="storage.storageId"
              >
                <div
                  class="storage-title clearfix"
                  @click.self="isShowStorage(storage.storageId)"
                >
                  <div class="title-info fl">
                    <i class="e6-icon-warehouse_fill storage-icon"></i>
                    <span class="storage-name"
                      >{{ storage.storageName
                      }}<em class="storage-type">{{
                        storage.storageMoldName
                      }}</em></span
                    >
                  </div>
                  <!-- 仓库条右边状态统计 -->
                  <div class="tag-group fr">
                    <el-button
                      v-if="storage.buildPlanPath"
                      type="primary"
                      sizi="mini"
                      class="check_photo_btn"
                      @click="openPhotoViewer(storage.buildPlanPath)"
                      >查看仓库平面图</el-button
                    >
                    <span class="tag-group__title"
                      >{{ storage.storageAreaCountAll }}个区位</span
                    >
                    <el-tag
                      class="tag-item"
                      v-bind:class="{
                        iszero: isZeroNormal(storage.storageAreaCountNormal)
                      }"
                    >
                      <span class="tag-color alarm-0"></span>
                      <span class="tag-font">正常</span>
                      <span class="tag-font">{{
                        storage.storageAreaCountNormal
                      }}</span>
                    </el-tag>
                    <el-tag
                      class="tag-item"
                      v-bind:class="{
                        iszero: isZeroAlarm(storage.storageAreaCountAlarm)
                      }"
                    >
                      <span class="tag-color alarm-2"></span>
                      <span class="tag-font">报警</span>
                      <span class="tag-font">{{
                        storage.storageAreaCountAlarm
                      }}</span>
                    </el-tag>
                    <el-tag
                      class="tag-item"
                      v-bind:class="{
                        iszero: isZeroDropLine(storage.storageAreaCountDropLine)
                      }"
                    >
                      <span class="tag-color alarm-3"></span>
                      <span class="tag-font">掉线</span>
                      <span class="tag-font">{{
                        storage.storageAreaCountDropLine
                      }}</span>
                    </el-tag>
                    <i
                      class="el-icon-arrow-right"
                      v-show="!isOpenning('storage-' + storage.storageId)"
                      @click.self="isShowStorage(storage.storageId)"
                    ></i>
                    <i
                      class="el-icon-arrow-down"
                      v-show="isOpenning('storage-' + storage.storageId)"
                      @click.self="isShowStorage(storage.storageId)"
                    ></i>
                  </div>
                </div>
                <!-- 区位列表 -->
                <div
                  class="area-list-wrapper clearfix"
                  v-show="isOpenning('storage-' + storage.storageId)"
                >
                  <!-- 区位 -->
                  <template v-for="area in storage.storageAreaList">
                    <div
                      class="label-list fl"
                      v-for="(label, index) in area.storageAreaLabelList"
                      :key="`${label.labelId}-${label.channelNum}`"
                    >
                      <!-- 只给每个区位下的第一个监测点加区位名 start-->
                      <div class="area-title">
                        <span
                          v-if="!index"
                          class="area-title-name"
                          :class="getAreaClassName(area)"
                          :title="area.storageAreaName"
                        >
                          {{ area.storageAreaName }}
                        </span>
                        <span v-if="!index" class="area-setting">
                          <template v-if="area.humRange || area.tempRange">
                            <span class="cGray">温湿度标准:</span> <br />
                            {{ area.humRange }}&nbsp;
                            {{ area.tempRange }}
                          </template>
                        </span>
                      </div>
                      <!-- end -->
                      <el-card
                        class="box-card"
                        :class="'status-' + label.status"
                      >
                        <div slot="header" class="clearfix">
                          <div class="item-name-box fl">
                            <span
                              class="area-item-name"
                              :title="label.labelName"
                              >{{ label.labelName }}</span
                            >
                          </div>
                          <div class="item-time-box fr">
                            <span
                              class="area-item-time"
                              v-if="label.time != '1900-01-01'"
                              >{{ label.time }}</span
                            >
                          </div>
                        </div>
                        <div class="card-body">
                          <div v-if="label.status === 3">
                            <div
                              class="nodata"
                              v-if="label.temperature === -999"
                            >
                              读取不到最新数据
                            </div>
                            <div class="card-tehu clearfix" v-else>
                              <div class="tehu-box fl no-data-item">
                                <!-- -999代表无效 用--代替 -->
                                <span
                                  class="tehu"
                                  v-if="
                                    label.temperature > 99 ||
                                      label.temperature < -99
                                  "
                                  >--
                                </span>
                                <span class="tehu" v-else
                                  >{{ label.temperature.toFixed(1) }}
                                </span>
                                <span>℃</span>
                                <i
                                  class="arrow"
                                  :class="getLabelTemArrow(label.alarmTypeStr)"
                                  v-if="
                                    label.temperature <= 99 &&
                                      label.temperature >= -99
                                  "
                                ></i>
                              </div>
                              <div class="tehu-box fl no-data-item">
                                <span
                                  class="tehu"
                                  v-if="
                                    label.humidity > 99 || label.humidity < -99
                                  "
                                  >--
                                </span>
                                <span class="tehu hum" v-else
                                  >{{ label.humidity }}
                                </span>
                                <span>%RH</span>
                                <i
                                  class="arrow"
                                  :class="getLabelHumArrow(label.alarmTypeStr)"
                                  v-if="
                                    label.humidity <= 99 &&
                                      label.humidity >= -99
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>

                          <div v-else>
                            <div class="card-tehu clearfix">
                              <div
                                class="tehu-box fl"
                                :class="isRedTem(label.alarmTypeStr)"
                              >
                                <!-- -999代表无效 用--代替 -->
                                <span
                                  class="tehu"
                                  v-if="
                                    label.temperature > 99 ||
                                      label.temperature < -99
                                  "
                                  >--
                                </span>
                                <span class="tehu" v-else
                                  >{{ label.temperature.toFixed(1) }}
                                </span>
                                <span>℃</span>
                                <i
                                  class="arrow"
                                  :class="getLabelTemArrow(label.alarmTypeStr)"
                                  v-if="
                                    label.temperature <= 99 &&
                                      label.temperature >= -99
                                  "
                                ></i>
                              </div>
                              <div
                                class="tehu-box fl"
                                :class="isRedHum(label.alarmTypeStr)"
                              >
                                <span
                                  class="tehu"
                                  v-if="
                                    label.humidity > 99 || label.humidity < -99
                                  "
                                  >--
                                </span>
                                <span class="tehu hum" v-else
                                  >{{ label.humidity }}
                                </span>
                                <span>%RH</span>
                                <i
                                  class="arrow"
                                  :class="getLabelHumArrow(label.alarmTypeStr)"
                                  v-if="
                                    label.humidity <= 99 &&
                                      label.humidity >= -99
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-card>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="nomore" v-if="this.comparyList.length">
            <span>已加载全部冷库</span>
          </div>
          <div class="nomore" v-if="!this.comparyList.length">
            <span>暂无数据</span>
          </div> -->
        </div>
        <!-- 翻页 -->
        <section class="pagination-section">
          <e6-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pageSize.sync="pageSize"
            :pageSizes="[10, 20]"
            :currentPage.sync="curPage"
            @currentChange="handleCurrentChange"
            @sizeChange="handleSizeChange"
          ></e6-pagination>
        </section>
        <!-- 翻页 end -->
      </div>
      <!-- 主体内容 end -->
      <e6-image-viewer
        v-show="showPhotoViewer"
        :on-close="closePhotoViewer"
        :url-list="photoArr"
      >
      </e6-image-viewer>
    </div>
    <StorageMap
      :class="{ 'is-show': isActiveCode === 2, 'is-hide': isActiveCode === 1 }"
    />
    <div class="btn-group">
      <div
        class="btn charts"
        :class="{ 'is-active': isActiveCode === 1 }"
        @click="isActiveCode = 1"
      >
        仓库监控
      </div>
      <div
        class="btn maps"
        :class="{ 'is-active': isActiveCode === 2 }"
        @click="isActiveCode = 2"
      >
        监控地图
      </div>
    </div>
  </div>
</template>
<script>
import resizeListener from "_private/mixins/resizeListener";
import { FetchStorageListByPage } from "../../../api/monitorCenter/storageList";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
// Component
import e6City from "e6city";
import StorageMap from "../storageMap/List";

export default {
  mixins: [resizeListener],
  components: { e6City, StorageMap },
  data() {
    return {
      loading: false,
      isAllShow: "全部收起",
      chooseStatus: "0", //切换状态按钮
      isAllShowStatus: true, //全部展开/收起状态
      autoRefresh: false, //自动刷新是否勾选
      checked: false,
      timeOut: "", //自动刷新 定时器
      searchFormVisible: false, //查询条件是否展开
      searchForm: {
        comparyName: "", //企业名称
        // provinceName: $GLOBAL_CONFIG.e6City.provinceName,
        provinceName: "",
        // cityName: $GLOBAL_CONFIG.e6City.cityName,
        cityName: "",
        countyName: "",
        status: 0, //监控的报警状态
        comparyIdList: [],
        storageName: "",
        storageMold: ""
      },
      searchHeight: 0,
      curPage: 1,
      total: 0,
      pageSize: 10,
      comparyList: [], // 当前展示的数据
      allComparyList: [], // 所有数据源
      openningList: [], //展开状态的企业、仓库id
      allComparys: [], //所有企业名称
      isActiveCode: 1, // 是否也换页面状态
      // 查看仓库平面图
      showPhotoViewer: false,
      photoArr: []
    };
  },
  computed: {
    //企业总数
    comparyAllCount() {
      let comparyNum = this.comparyList.length;
      return comparyNum;
    },
    //仓库总数
    storageAllCount() {
      let storageNum = 0;
      this.comparyList.forEach(item => {
        storageNum += item.storageList.length;
      });
      return storageNum;
    },
    //区位总数
    areaAllCount() {
      let areaNum = 0;
      this.comparyList.forEach(item => {
        item.storageList.forEach(area => {
          areaNum += area.storageAreaList.length;
        });
      });
      return areaNum;
    },
    //监测点总数
    labelAllCount() {
      let labelNum = 0;
      this.comparyList.forEach(item => {
        item.storageList.forEach(area => {
          area.storageAreaList.forEach(label => {
            labelNum += label.storageAreaLabelList.length;
          });
        });
      });
      return labelNum;
    }
  },
  created() {
    this.initAllComparys();
    if (this.$route.query.companyId && this.$route.query.status) {
      this.searchForm.comparyIdList.push(parseInt(this.$route.query.companyId));
      this.searchForm.status = this.$route.query.status;
      this.chooseStatus = this.$route.query.status;
    }
    if (this.$route.query.storageType) {
      this.searchForm.storageMold = Number(this.$route.query.storageType);
    }
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.getInitData();
    //监听数据
    this.getListIng();
  },
  destroyed: function() {
    clearTimeout(this.timeOut);
    this.timeOut = "";
  },
  methods: {
    // 分页
    getCurPageIndex() {
      let startIndex = this.pageSize * (this.curPage - 1);
      let lastIndex = this.pageSize * this.curPage;
      return [startIndex, lastIndex];
    },
    //获取数据
    getInitData() {
      this.loading = true;
      FetchStorageListByPage(this.searchForm)
        .then(res => {
          let comparyList = [];
          this.openningList = [];
          if (res.code === 1 && Array.isArray(res.result.comparyList)) {
            comparyList = res.result.comparyList;
          }
          this.allComparyList = comparyList;
          this.total = this.allComparyList.length;
          this.showCurpageData();
          this.handleIsAllShow(true);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 打开查看仓库平面图
    openPhotoViewer(url) {
      this.showPhotoViewer = true;
      this.photoArr = url.split(",");
    },
    // 关闭查看仓库平面图
    closePhotoViewer() {
      this.showPhotoViewer = false;
    },
    // 组装当页数据
    showCurpageData() {
      this.comparyList = [];
      let dataIndexArr = this.getCurPageIndex();
      this.comparyList = this.allComparyList.filter((v, i) => {
        return i >= dataIndexArr[0] && i < dataIndexArr[1];
      });

      this.comparyList.forEach(compary => {
        this.openningList.push("corp-" + compary.comparyId);
        compary.storageList.forEach(storage => {
          this.openningList.push("storage-" + storage.storageId);
        });
      });
    },
    //企业是否展开
    isShowCompary(id) {
      let idStr = "corp-" + id;
      if (this.openningList.includes(idStr)) {
        this.openningList.splice(
          this.openningList.findIndex(item => item === idStr),
          1
        );
      } else {
        this.openningList.push(idStr);
      }
    },
    //仓库是否展开
    isShowStorage(id) {
      let idStr = "storage-" + id;
      if (this.openningList.includes(idStr)) {
        this.openningList.splice(
          this.openningList.findIndex(item => item === idStr),
          1
        );
      } else {
        this.openningList.push(idStr);
      }
    },
    //控制展开收起
    isOpenning(itemStr) {
      return this.openningList.includes(itemStr);
    },
    //全部展开&全部收起状态切换
    handleIsAllShow(type) {
      if (type === true) {
        this.isAllShowStatus = type;
      } else {
        this.isAllShowStatus = !this.isAllShowStatus;
      }
      if (this.isAllShowStatus) {
        this.isAllShow = "全部收起";
        this.comparyList.forEach(compary => {
          let comStr = "corp-" + compary.comparyId;
          if (!this.openningList.includes(comStr)) {
            this.openningList.push(comStr);
          }
          compary.storageList.forEach(storage => {
            let storageStr = "storage-" + storage.storageId;
            if (!this.openningList.includes(storageStr)) {
              this.openningList.push(storageStr);
            }
          });
        });
      } else {
        this.isAllShow = "全部展开";
        this.openningList = [];
      }
    },
    //状态按钮改变事件
    selectStatus(val) {
      this.searchForm.status = +val; //字符串转数字
      this.getInitData();
    },
    //监听数据
    getListIng() {
      let _this = this;
      //判断是否自动刷新数据
      if (this.autoRefresh) {
        this.getInitData(); //请求的函数
        this.timeOut = setTimeout(() => {
          _this.getListIng();
        }, 30000);
      }
    },
    //自动刷新
    autoRefreshEvent(checked) {
      this.autoRefresh = checked;
      if (checked) {
        //监听数据
        this.getListIng();
      } else {
        //清空定时器
        clearTimeout(this.timeOut);
        this.timeOut = "";
      }
    },
    //查询条件显示隐藏
    handleSearchFormVisible() {
      this.searchFormVisible = !this.searchFormVisible;
      this.searchFormVisible
        ? (this.searchHeight = 60)
        : (this.searchHeight = 0);
    },
    //查询
    handleQuery(val) {
      if (val) {
        this.searchForm.status = val;
      }
      this.getInitData();
    },
    //重置
    handleReset() {
      this.$refs["searchForm"].resetFields();
      this.$refs["e6City"].clearCity();
      this.searchForm.provinceName = "";
      this.searchForm.cityName = "";
      this.searchForm.countyName = "";
      this.$refs.e6City.clearCity();
    },
    //区位名 颜色类名
    getAreaClassName(area) {
      let status = [];
      area.storageAreaLabelList.forEach(label => {
        status.push(label.status);
      });
      if (status.includes(2)) {
        return "alarm-2";
      } else if (status.includes(3)) {
        return "alarm-3";
      } else {
        return "alarm-0";
      }
    },
    // 区位状态数为0的置灰
    isZeroNormal(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    isZeroAlarm(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    isZeroDropLine(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    //温度报警箭头
    getLabelTemArrow(alarmStr) {
      if (alarmStr.includes("1-1-1")) {
        return "e6-icon-grade-_fill2";
      }
      if (alarmStr.includes("1-1-2")) {
        return "e6-icon-grade-_fill1";
      }
      if (alarmStr.includes("1-1-3")) {
        return "e6-icon-grade-_fill";
      }
      if (alarmStr.includes("1-2-1")) {
        return "e6-icon-grade-_fill2 irotate";
      }
      if (alarmStr.includes("1-2-2")) {
        return "e6-icon-grade-_fill1 irotate";
      }
      if (alarmStr.includes("1-2-3")) {
        return "e6-icon-grade-_fill irotate";
      }
    },
    //湿度报警箭头
    getLabelHumArrow(alarmStr) {
      if (alarmStr.includes("2-1-1")) {
        return "e6-icon-grade-_fill2";
      }
      if (alarmStr.includes("2-1-2")) {
        return "e6-icon-grade-_fill1";
      }
      if (alarmStr.includes("2-1-3")) {
        return "e6-icon-grade-_fill";
      }
      if (alarmStr.includes("2-2-1")) {
        return "e6-icon-grade-_fill2 irotate";
      }
      if (alarmStr.includes("2-2-2")) {
        return "e6-icon-grade-_fill1 irotate";
      }
      if (alarmStr.includes("2-2-3")) {
        return "e6-icon-grade-_fill irotate";
      }
    },
    //温度字体颜色
    isRedTem(alarmStr) {
      if (alarmStr.includes("1-1-") || alarmStr.includes("1-2-")) {
        return "isred2";
      } else {
        return "isred0";
      }
    },
    //湿度字体颜色
    isRedHum(alarmStr) {
      if (alarmStr.includes("2-1-") || alarmStr.includes("2-2-")) {
        return "isred2";
      } else {
        return "isred0";
      }
    },
    /**
     *  初始化企业
     */
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (
        res.province.name == "澳门" ||
        res.province.name == "香港" ||
        res.province.name == "台湾省"
      ) {
        this.searchForm.provinceName = res.province.name;
        this.searchForm.cityName = res.province.name;
      } else {
        this.searchForm.provinceName = res.province.name;
        this.searchForm.cityName = res.city.name;
        this.searchForm.countyName = res.district.name;
      }
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.showCurpageData();
      this.handleIsAllShow(true);
      this.$refs.company.scrollTop = 0; //滚动条回到顶部
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.curPage = 1;
      this.pageSize = e;
      this.getInitData();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100%;
  .check_photo_btn {
    margin-right: 10px;
    border-radius: 15px;
  }

  // 冷库监控页面
  .container-view,
  .mContainer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  // 按钮组
  .btn-group {
    position: absolute;
    top: 4px;
    left: 20px;
    display: flex;
    border: 1px solid #5ec2ff;
    border-radius: 10px;
    font-size: 14px;
    background-color: #fff;
    cursor: pointer;
    z-index: 999;

    .btn {
      // margin-right: 15px;
      padding: 6px 10px;
    }

    .charts {
      border-radius: 8px 0 0 8px;
    }

    .maps {
      border-radius: 0 8px 8px 0;
    }

    //选中状态
    .is-active {
      color: #fff;
      background-color: #5ec2ff;
    }
  }
  .is-hide {
    visibility: hidden;
    z-index: -99999999;
  }
}
@import "../../../assets/styles/storage.scss";
@import "../../../assets/iconFont/iconfont.css";
</style>
